import { request } from 'coderz-utils/index-no-deps'

class Courses {
  static getCoursesList () {
    return request({ url: '@store/product/get-all' })
  }
}

export default Courses
